import React from "react";
import CustomCarousel from "../Carousel";
// import ContentModal from "../ContentModal";
import News from "../News";
import useFetch from '../../hooks/useFetch'
import { List } from "antd";

const MainContent = () => {

  // 轮播图数据
  const pictures = useFetch("http://1.94.62.64:9090/myf/getHeadPicture")
  const leftNewsMsg = useFetch('http://1.94.62.64:9090/myf/getActivities')
  const rightNewsMsg = useFetch('http://1.94.62.64:9090/myf/getNews')
  // const msg = useFetch('http://1.94.62.64:9090/myf/getBusiness')

  const companyNews = rightNewsMsg?.filter((item) => {
    return item.type === 0
  })

  const industryNews = rightNewsMsg?.filter((item) => {
    return item.type === 1
  })

  return (
    <div className="flex flex-col justify-center items-center">
      <CustomCarousel pictures={pictures} />
      <section
        className="flex flex-col items-center my-[100px]"
      >
        <h4 className="font-bold mb-12 text-3xl">新闻与活动</h4>
        {(leftNewsMsg && rightNewsMsg) && (
          <News leftNewsMsg={leftNewsMsg} rightNewsMsg={companyNews} />
        )}
      </section>
      {
        industryNews?.length !== 0 && <section className="mb-[60px] w-[1000px] flex flex-col items-center">
          <h4 className="text-3xl font-bold mb-12">业界动态</h4>
          <div className="w-full h-96 bg-slate-100 rounded-md">
            <List
              className="w-full px-8 py-4"
              dataSource={industryNews}
              renderItem={(item) => {
                const { title, time, link } = item
                let url = ''
                let content = (
                  <span className="text-sm">
                    {title}
                  </span>
                )

                if (link !== '') {
                  url = link.startsWith("https") ? link : 'https://' + link
                  content = (
                    <a href={url} target="_blank">
                      <span className="text-sm">
                        {title}
                      </span>
                    </a>
                  )
                }
                return (
                  <List.Item>
                    <List.Item.Meta
                      title={content}
                      description={time}
                    />
                  </List.Item>
                )
              }}
            />
          </div>
        </section>
      }
      {/* <section
        className="flex items-center flex-col">
        <h4 className="text-3xl font-bold">业务布局</h4>
        {msg && msg.map((item) => {
          return (
            <ContentModal
              key={item.id}
              header={item.businessName}
              text={item.businessContent}
              imgUrl={item.picture}
              url={item.url}
            />
          );
        })}
      </section> */}
    </div>
  );
};

export default MainContent;
